module.exports = __webpack_public_path__ + "static/media/arrow-up-green.e2ea7eb8.svg";